import React, { useEffect, useState } from "react";
import { FcAlarmClock } from "react-icons/fc";
import { useNavigate } from "react-router-dom";

/**
 * Page d'erreur - Session Expirée
 * Affichée quand le token d'authentification expire
 */
export default function Error() {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(10);

  // Redirection automatique après 10 secondes
  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          // Nettoyer la session et rediriger
          localStorage.removeItem("token");
          localStorage.removeItem("user");
          navigate("/auth/login");
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  const handleLoginRedirect = () => {
    // Nettoyer les données de session avant redirection
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    navigate("/auth/login");
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-purple-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full">
        {/* Card principale */}
        <div className="bg-white rounded-2xl shadow-xl p-6 md:p-8 text-center">

          {/* Icône d'alerte */}
          <div className="mb-6">
            <div className="w-20 h-20 md:w-24 md:h-24 bg-orange-100 rounded-full flex items-center justify-center mx-auto">
              <svg
                className="w-12 h-12 md:w-14 md:h-14 text-orange-500"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                />
              </svg>
            </div>
          </div>

          {/* Message principal */}
          <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-3 flex justify-center items-center gap-4">
            <FcAlarmClock /> Session Expirée
          </h2>

          <p className="text-gray-600 mb-2 text-sm md:text-base">
            Votre session a expiré pour des raisons de sécurité.
          </p>

          <p className="text-gray-600 mb-6 text-sm md:text-base">
            Veuillez vous reconnecter pour continuer à utiliser CAPITALYA.
          </p>


          {/* Compteur de redirection */}
          <div className="mb-6">
            <div className="inline-flex items-center gap-2 bg-gray-100 px-4 py-2 rounded-full">
              <div className="w-2 h-2 bg-blue-600 rounded-full animate-pulse"></div>
              <span className="text-sm text-gray-700">
                Redirection dans{" "}
                <span className="font-bold text-blue-600">{countdown}s</span>
              </span>
            </div>
          </div>

          {/* Boutons d'action */}
          <div className="space-y-3">
            <button
              onClick={handleLoginRedirect}
              className="w-full bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white font-bold py-3 md:py-4 px-6 rounded-lg transition-all duration-300 transform hover:scale-105 shadow-lg"
            >
              🔐 Se Reconnecter Maintenant
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}